import { gql } from '@apollo/client';
import organizationFragment from './organizationFragment';

const GET_ORGANIZATIONS_WITH_LICENSES = gql`
  query GetOrganizationsWithLicenseInfo(
    $filters: [FilterInput!]
    $offset: Int
    $limit: Int
    $isVipOrganization: Boolean
    $includeDeactivated: Boolean
  ) {
    mddapOrganizationsFiltered(
      filters: $filters
      offset: $offset
      limit: $limit
      isVipOrganization: $isVipOrganization
      includeDeactivated: $includeDeactivated
    ) {
      ...OrganizationFields
      PaidAssigned
      PaidTotal
      OrgUnitsPaidTotal
      OrgUnitsPaidAssigned
    }
    mddapOrganizationsFilteredCount(
      filters: $filters
      isVipOrganization: $isVipOrganization
      includeDeactivated: $includeDeactivated
    )
  }
  ${organizationFragment}
`;

export default GET_ORGANIZATIONS_WITH_LICENSES;
